import styled from 'styled-components';

export const ScCancelBonusModalContainer = styled.div`
  padding: 0 8px;
`;

export const ScCancelBonusModal = styled.div`
  position: relative;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  gap: 32px;
  max-width: 480px;
  width: 100%;
  background-color: ${({ theme }) => theme.whiteColor};
  border-radius: 24px;
  padding: 32px;

  & > .text-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: center;
    color: ${({ theme }) => theme.blackColor};

    & > .title {
      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0.44px;
      text-transform: uppercase;
    }

    & > .warning {
      font-size: 16px;
      line-height: 24px;
    }
  }

  & > .btn-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;
